export const MUTUAL_FUND = 'Mutual Funds'
export const ETF_FUND = 'Exchange Traded Fund'
export const ETF_INDEX_FUND = 'Exchange Traded Fund Index'
export const FUTURE_SCHOLAR_529 = 'Future Scholar 529'
export const VARIABLE_FUND = 'Variable'
export const CLOSED_END_FUND = 'Closed End'
export const MODEL_PORTFOLIOS = 'Model Portfolios'
export const INTERVAL_FUND = 'Interval Fund'

export const RETAIL_PRODUCTS = 'Retail'
export const CLOSED_END_PRODUCTS = 'ClosedEnd'
export const ETF_PRODUCTS = 'RetailETF'
export const FUTURE_SCHOLAR_529_PRODUCTS = 'FutureScholar529'
export const VARIABLE_PRODUCTS = 'VariableProducts'
export const MODEL_PORTFOLIOS_PRODUCTS = 'ModelPortfolios'
export const INTERVAL_FUND_PRODUCTS = 'IntervalFund'

export const MUTUAL_FUND_PATH = 'mutual-funds'
export const ETF_PATH = 'exchange-traded-funds'
export const FUTURE_SCHOLAR_529_PATH = '529-plan'
export const VARIABLE_PATH = 'variable-products'
export const CLOSED_END_PATH = 'closed-end-funds'
export const MODEL_PORTFOLIOS_PATH = 'model-portfolios'
export const INTERVAL_FUND_PATH = 'interval-funds'

const productTypeAttributes = {
  'Future Scholar 529': {
    productUILabel: '529 Plan',
    fundGroup: FUTURE_SCHOLAR_529,
    productListType: FUTURE_SCHOLAR_529_PRODUCTS,
    path: FUTURE_SCHOLAR_529_PATH,
  },
  Retail: {
    productUILabel: 'Mutual Funds',
    fundGroup: MUTUAL_FUND,
    productListType: RETAIL_PRODUCTS,
    path: MUTUAL_FUND_PATH,
  },
  'Model Portfolios': {
    productUILabel: 'Model Portfolios',
    fundGroup: MODEL_PORTFOLIOS,
    productListType: MODEL_PORTFOLIOS_PRODUCTS,
    path: MODEL_PORTFOLIOS_PATH,
  },
  'Retail ETF': {
    productUILabel: 'Exchange Traded Funds (ETFs)',
    fundGroup: ETF_FUND,
    productListType: ETF_PRODUCTS,
    path: ETF_PATH,
  },
  'Closed End': {
    productUILabel: 'Listed Closed-End Funds',
    fundGroup: CLOSED_END_FUND,
    productListType: CLOSED_END_PRODUCTS,
    path: CLOSED_END_PATH,
  },
  'Variable Products': {
    productUILabel: 'Variable Products',
    fundGroup: VARIABLE_FUND,
    productListType: VARIABLE_PRODUCTS,
    path: VARIABLE_PATH,
  },
  'Retail and Institutional': {
    productUILabel: 'Mutual Funds',
    fundGroup: MUTUAL_FUND,
    productListType: RETAIL_PRODUCTS,
    path: MUTUAL_FUND_PATH,
  },
  'Interval Fund': {
    productUILabel: 'Interval Funds',
    fundGroup: INTERVAL_FUND,
    productListType: INTERVAL_FUND_PRODUCTS,
    path: INTERVAL_FUND_PATH,
  },
}

export const getProductPropertyByValue = (prop1, value, prop2) => {
  if (productTypeAttributes[value]?.[prop1]) {
    return productTypeAttributes[value][prop1]
  } else {
    const selection = Object.keys(productTypeAttributes).filter(
      (type) => productTypeAttributes[type][prop1] === value
    )

    if (selection.length > 1) {
      return selection
    } else {
      return selection
        ? prop2
          ? productTypeAttributes[selection?.[0]]?.[prop2]
          : selection[0]
        : null
    }
  }
}

export const getProductTypeByPath = (productType) => {
  switch (productType) {
    case MUTUAL_FUND_PATH:
      return RETAIL_PRODUCTS
    case ETF_PATH:
      return ETF_PRODUCTS
    case FUTURE_SCHOLAR_529_PATH:
      return FUTURE_SCHOLAR_529_PRODUCTS
    case VARIABLE_PATH:
      return VARIABLE_PRODUCTS
    case CLOSED_END_PATH:
      return CLOSED_END_PRODUCTS
    case MODEL_PORTFOLIOS_PATH:
      return MODEL_PORTFOLIOS_PRODUCTS
    case INTERVAL_FUND_PRODUCTS:
      return INTERVAL_FUND_PRODUCTS
    default:
      return MUTUAL_FUND_PATH
  }
}
